// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck "Works"
export const useApi: typeof useFetch = (url, opts?) => {
  const config = useRuntimeConfig()

  return useFetch(url, {
    baseURL: config.public.baseURL,
    credentials: 'include',

    onRequest({ options }) {
      options.headers = setupHeaders(options.headers)
    },

    onResponseError({ response }) {
      if ([404, 500].includes(response.status)) {
        showError({
          // @ts-expect-error "TBD"
          message: response._data?.detail ?? 'Unknown error',
          statusCode: response.status,
        })
        return
      }
    },

    ...opts,
  })
}
